/**
 * AD-828: how the own-avatar reconcile treats a jump (pure; Game.ts `reconcile`).
 *
 * - `smooth`: a small prediction error (≤ `snapM`) glides out through the correction offset.
 * - `dash`: the server just moved us with an ability dash (`abilityUsed.dash`, inside the
 *   window): the whole jump, up to the dash cap, glides too — once.
 * - `snap`: anything else larger is a real divergence and snaps.
 */
export function reconcileMode(
  errM: number,
  nowMs: number,
  dashBlendUntilMs: number,
  snapM: number,
  dashMaxM: number,
): 'smooth' | 'dash' | 'snap' {
  if (errM <= snapM) return 'smooth';
  if (nowMs < dashBlendUntilMs && errM <= dashMaxM + snapM) return 'dash';
  return 'snap';
}
